module.exports = __webpack_public_path__ + "img/logo-acaplast-white-placeholder.8d02251d.jpg";